export default __webpack_public_path__ + "static/media/marly.7efc3896.png";